<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col cols="12">
                    <h1 class="headline font-weight-light mb-3">POSNET</h1>
                </v-col>
            </v-row>

            <v-row class="mt-3">
                <v-col
                    cols="6"
                    sm="5"
                    md="3"
                    class="cur-p"
                    v-for="(row, idex) in data_group"
                    :key="idex"
                >
                    <v-card
                        :disabled="row.count == 0"
                        :color="
                            row.case_status_name === chk_btn
                                ? 'teal accent-1'
                                : ''
                        "
                        @click="get_data(idex, row.case_status_name)"
                    >
                        <v-list-item two-line>
                            <v-list-item-content>
                                <b>{{ row.case_status_name }}</b>
                            </v-list-item-content>
                            <v-btn fab dark small color="teal accent-3">{{
                                row.count
                            }}</v-btn>
                        </v-list-item>
                    </v-card>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="4">
                    <v-text-field
                        outlined
                        dense
                        @input="func_search_case()"
                        v-model="search_case"
                        label="Search Case"
                        prepend-inner-icon="mdi-magnify"
                    ></v-text-field>
                </v-col>

                <v-col cols="12" v-if="chk_cheng == 1">
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center">#</th>
                                    <th class="text-center">Case</th>
                                    <th class="text-center">
                                        Open Case / Operation
                                    </th>
                                    <th class="text-center">Customer</th>
                                    <th class="text-center">Address</th>
                                    <th class="text-center">
                                        ใบงาน / รายละเอียดเครือง
                                    </th>
                                    <th class="text-center">EDC Items</th>
                                    <th class="text-center">
                                        <v-btn
                                            small
                                            :color="
                                                chk_checkbox == false
                                                    ? ''
                                                    : 'success'
                                            "
                                            rounded
                                            @click="checkbox_all()"
                                        >
                                            All
                                        </v-btn>
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="data_main.length == 0">
                                <tr>
                                    <td class="text-center" colspan="8">
                                        no results found
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(r, i) in data_main" :key="i">
                                    <td class="text-center">{{ i + 1 }}.</td>
                                    <td>
                                        <v-btn
                                            rounded
                                            small
                                            class="primary--text"
                                        >
                                            {{ r.case_id }}
                                        </v-btn>
                                        <v-chip small class="ml-1 mr-1">
                                            {{ r.caseType }}
                                        </v-chip>
                                        <v-chip small>
                                            {{ r.bank }}
                                        </v-chip>
                                        <br />
                                        <span class="blue-grey--text">
                                            {{ r.issue }}
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <span class="blue-grey--text">
                                            {{ r.openCaseDate }}
                                        </span>
                                        <br />
                                        <span class="primary--text">
                                            {{ r.operationDate }}
                                        </span>
                                    </td>
                                    <td>
                                        {{ r.contactName }} <br />
                                        {{ r.contactTel }}
                                    </td>
                                    <td>
                                        <span>
                                            {{ r.shopNameTH }}
                                        </span>
                                        <br />
                                        <span class="primary--text">
                                            {{ r.address }}
                                        </span>
                                    </td>
                                    <td class="text-center">
                                        <v-btn
                                            x-small
                                            fab
                                            class="mr-1"
                                            @click="
                                                get_doc(r.worksheetEdcPdfUrl)
                                            "
                                        >
                                            <v-icon color="primary">
                                                mdi-file-multiple
                                            </v-icon>
                                        </v-btn>
                                        <v-btn
                                            x-small
                                            fab
                                            @click="get_doc(r.worksheetPdfUrl)"
                                        >
                                            <v-icon color="red">
                                                mdi-clipboard-text
                                            </v-icon>
                                        </v-btn>
                                    </td>
                                    <td class="text-center">
                                        <v-btn
                                            small
                                            color="amber"
                                            rounded
                                            @click="show_part(r.posnet_parts)"
                                        >
                                            {{
                                                "Total : " +
                                                r.posnet_parts.length
                                            }}
                                        </v-btn>
                                    </td>
                                    <td class="text-center">
                                        <v-switch
                                            flat
                                            v-model="checkbox"
                                            :value="r.posnet_id"
                                        ></v-switch>
                                    </td>
                                </tr>
                                <br />
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="dialogLog" width="500">
            <v-card>
                <v-card-title class="subtitle-1 primary--text">
                    EDC Items
                </v-card-title>
                <v-card-text>
                    <v-row v-for="(pp, idx) in data_part" :key="idx">
                        <v-col cols="6">
                            <b>MID : {{ pp.mid }} </b>
                        </v-col>
                        <v-col cols="6">
                            <b>TID : {{ pp.tid }} </b>
                        </v-col>
                        <v-col cols="12">
                            <b>Serial : {{ pp.serial }} </b>
                        </v-col>
                        <v-col cols="12">
                            <hr v-if="data_part.length > 1" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogLog = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    mounted() {
        this.get_group_data()
        this.get_data(this.chk_cheng, this.chk_btn)
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    computed: {
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_group_data() {
            this.dialog_loading = true
            await axios
                .get(url + "partner/posnet/get-group-data", this.tk)
                .then((response) => {
                    this.data_group = response.data
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data(type, name) {
            this.chk_cheng = type + 1
            this.chk_btn = name
            this.dialog_loading = true
            await axios
                .get(url + "partner/posnet/get-data/" + this.chk_cheng, this.tk)
                .then((response) => {
                    console.log(response, "-get datas")
                    this.data_main = response.data
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        get_doc(urlx) {
            window.open(urlx, "_blank")
        },
        show_part(part) {
            this.data_part = []
            this.data_part = part
            this.dialogLog = true
        },
        checkbox_all() {
            if (this.chk_checkbox == false) {
                this.checkbox = []
                this.data_main.map((each) => {
                    this.checkbox.push(each.posnet_id)
                })
                this.chk_checkbox = true
            } else {
                this.checkbox = []
                this.chk_checkbox = false
            }
        },
        func_search_case() {
            // if (this.search_case.length >= 1) {
            //     let datak = []
            //     this.data_main.map((each, index) => {
            //         if (this.search_case == each.case_id) {
            //             datak[0] = each
            //         }
            //     })
            //     this.data_main = datak
            // } else if (this.search_case.length == 0) {
            //     this.get_data(this.chk_cheng - 1, this.chk_btn)
            // }
        },

        // async save_data() {
        //     this.dialog_loading = true
        //     await axios
        //         .get(url + "partner/posnet/get-data", this.tk)
        //         .then((response) => {
        //             console.log(response, "-get datas")
        //             // this.data_main = response.data
        //             this.dialog_loading = false
        //             this.mutatesnackbar()
        //             if (this.snackbar === true) {
        //                 setTimeout(() => {
        //                     this.mutatesnackbar()
        //                 }, 3000)
        //             }
        //         })
        //         .catch((error) => {
        //             console.log(error)
        //         })
        // },
    },
    data() {
        return {
            tk: null,
            data_group: [],
            data_main: [],
            data_part: [],
            text: "Success, Your work has been saved",
            dialog_loading: false,
            dialogLog: false,
            chk_btn: "Incomming Case",
            checkbox: [],
            chk_checkbox: false,
            chk_cheng: 0,
            search_case: null,
        }
    },
}
</script>
